import React, { Component } from 'react';

/**
 * Analytics HOC factory
 * Creates and returns a higher-order component which wraps the supplied component.
 * Handles Analytics logic.
 * @type {function} Analytics
 * @param {component} ComposedComponent - The component to wrap in the returned Analytics HOC
 * @param {string} pageName - The page container's canonical page name
 * @param {Object} analytics - Bespoke methods to be invoked by Analytics framework events
 * @param {Array} analyticsProviders - Analytics service providers used (e.g. Google Analytics)
 * @returns {Class} An Analytics HOC class
 */
export default function Analytics(ComposedComponent, pageName, analytics, analyticsProviders) {
	return class extends Component {
		static propTypes = {
			analyticsData: React.PropTypes.object.isRequired
		};
		constructor(props) {
			super(props);
		}
		componentWillMount() {
			const { analyticsData } = this.props;
			this.trackPageView(analyticsData);
		}
		/**
		 * Track a SPA 'page view' to provided analytics providers
		 * @param {object} analyticsData - pertinent tracking data required by providers
		 */
		trackPageView(analyticsData) {
			analyticsProviders.forEach(provider => {
				provider.trackPageView(pageName, analyticsData);
			});
			// Opportunity to fire bespoke actions provided by analytics when a given page is viewed
			analytics.pageView && analytics.pageView(pageName, analyticsData, analyticsProviders);
		}
		render() {
			return <ComposedComponent {...this.props} />;
		}
	};
}



// WEBPACK FOOTER //
// ../~/dna-react-analytics/components/analytics/Analytics.js